import type { Course } from './types';

export type LessonLocation={moduleIndex:number;lessonIndex:number;moduleId:string;lessonId:string};

export const lessonLocations=(course:Course):LessonLocation[]=>course.modules.flatMap((module,moduleIndex)=>module.lessons.map((lesson,lessonIndex)=>({moduleIndex,lessonIndex,moduleId:module.id,lessonId:lesson.id})));
export const requiredLessonIds=(course:Course)=>lessonLocations(course).map(location=>location.lessonId);
export const findLessonLocation=(course:Course,moduleId?:string,lessonId?:string):LessonLocation=>{
 const locations=lessonLocations(course);return locations.find(item=>item.lessonId===lessonId&&(!moduleId||item.moduleId===moduleId))??locations.find(item=>item.moduleId===moduleId)??locations[0];
};
export const adjacentLesson=(course:Course,currentLessonId:string,delta:-1|1):LessonLocation|undefined=>{
 const locations=lessonLocations(course);const index=locations.findIndex(item=>item.lessonId===currentLessonId);return index<0?locations[0]:locations[index+delta];
};
export const moduleIsComplete=(course:Course,moduleId:string,completedLessonIds:string[])=>{
 const module=course.modules.find(item=>item.id===moduleId);return Boolean(module?.lessons.length&&module.lessons.every(lesson=>completedLessonIds.includes(lesson.id)));
};
export const lessonProgress=(course:Course,completedLessonIds:string[])=>{
 const required=requiredLessonIds(course);return required.length?Math.round(required.filter(id=>completedLessonIds.includes(id)).length/required.length*100):0;
};
